module.exports = __webpack_public_path__ + "img/ip.3b52bd9.png";